import axios from 'axios';
import { signIn, getCurrentUser} from 'aws-amplify/auth';

interface SignUpData {
  userAccount: string;
  username: string;
  userPassword: string;
  checkPassword: string;
}

interface User {
  id: number;
  userAccount: string;
  userRole: number;
  createTime: string;
  username: string;
}

export const registerNewUser = async (signUpData: SignUpData): Promise<any> => {
  try {
    const response = await axios.post("/user/newuser", signUpData);
    return response.data;
  } catch (error) {
    throw new Error("An error occurred while registering. Please try again later.");
  }
};

export async function handleSignIn({ username, password }) {
  try {
    const { isSignedIn, nextStep } = await signIn({ username, password });
    return { isSignedIn, nextStep };  
  } catch (error) {
    console.log('error signing in', error);
    throw error;  
  }
};

export const fetchUsers = async (): Promise<User[]> => {
  try {
    const response = await axios.get('/user/list');
    return response.data.data as User[];
  } catch (error) {
    console.error('Failed to fetch users:', error);
    throw error; 
  }
};

export async function currentAuthenticatedUser() {
  try {
    const { username, userId, signInDetails } = await getCurrentUser();
    console.log(`The username: ${username}`);
    console.log(`The userId: ${userId}`);
    console.log(`The signInDetails: ${signInDetails}`);
  } catch (err) {
    console.log(err);
  }
};
